








import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import { GET_ANSWER_BY_ID, SET_MULTICHOICE_ANSWER } from "@/store/types";
export default Vue.extend({
  name: "MultichoiceAnswer",

  props: {
    answer: {
      type: Object,
      required: true
    },
    questionId: {
      type: [Number, String],
      required: true
    }
  },

  components: {
    CheckboxGroup: () => import("@/components/Form/CheckboxGroup.vue")
  },

  computed: {
    ...mapGetters({
      getAnswerObject: GET_ANSWER_BY_ID
    }),

    answerModel: {
      get(): boolean {
        const answerObject = this.getAnswerObject(this.questionId);

        if (answerObject && {}.hasOwnProperty.call(answerObject, "answers")) {
          const answer = answerObject.answers.find(
            ans => ans.id === this.answer.id
          );
          return answer ? true : false;
        }

        return false;
      },

      set(isChecked: boolean): void {
        this.setMultichoiceAnswer({
          questionId: this.questionId,
          answerId: this.answer.id,
          isChecked
        });
      }
    }
  },

  methods: {
    ...mapMutations({
      setMultichoiceAnswer: SET_MULTICHOICE_ANSWER
    })
  }
});
